import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* getNotificationCount() {
  yield takeEvery(actionTypes.GET_NOTIFICATION_COUNT, function* (action) {
    try {
      const response = yield API.getNotificationCount();
      if (response.data.success) {
        yield put(
          actions.getNotificationCountSuccess(response.data.data.unread)
        );
      } else {
        // console.log(
        //   "Warning: Fail to get notification count. \n" + response.data.message
        // );
        yield put(actions.getNotificationCountFail());
      }
    } catch (error) {
      //   console.log(
      //     API.constructErrMsg(
      //       "Error: Fail to get notification count. \n" + action.error
      //     )
      //   );
      yield put(actions.getNotificationCountFail());
    }
  });
}

export function* loadNotificationList() {
  yield takeEvery(actionTypes.LOAD_NOTIFICATION_LIST, function* (action) {
    try {
      const response = yield API.loadNotificationList(action.data);
      if (response.data.success) {
        yield put(actions.loadNotificationListSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to load notification list. \n" + response.data.message
        );
        yield put(actions.getNotificationCountFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load notification list.")
      );
      yield put(actions.getNotificationCountFail());
    }
  });
}

export function* deleteNotification() {
  yield takeEvery(actionTypes.DELETE_NOTIFICATION, function* (action) {
    yield put(actions.enableLoading());

    try {
      const response = yield API.deleteNotification(action.id, action.data);
      if (response.data.success) {
        yield put(actions.deleteNotificationSuccess());
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.loadNotificationList({ offset: 0, limit: 10 }));
      } else {
        alert(
          "Warning: Fail to delete notification. \n" + response.data.message
        );
        yield put(actions.deleteNotificationFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to delete notification."));
      yield put(actions.deleteNotificationFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* markNotificationAsRead() {
  yield takeEvery(actionTypes.MARK_NOTIFICATION_AS_READ, function* (action) {
    try {
      const response = yield API.markNotificationAsRead(action.id, action.data);
      if (response.data.success) {
        yield put(actions.markNotificationAsReadSuccess());
        yield put(actions.getNotificationCount());
      } else {
        // console.log(
        //   "Warning: Fail to mark notification as read. \n" +
        //     response.data.message
        // );
        yield put(actions.markNotificationAsReadFail());
      }
    } catch (error) {
      //   console.log(
      //     API.constructErrMsg(
      //       "Error: Fail to mark notification as read. \n" + action.error
      //     )
      //   );
      yield put(actions.markNotificationAsReadFail());
    }
  });
}

export default function* notificationSaga() {
  yield all([
    fork(getNotificationCount),
    fork(loadNotificationList),
    fork(deleteNotification),
    fork(markNotificationAsRead),
  ]);
}
